<div class="p-0 main-indicators">
  <ng-container *ngFor="let indicator of indicators; let i = index;">
    <app-card-indicator [indicator]="indicator"></app-card-indicator>

    <!-- divider -->
    <div *ngIf="i < indicators.length - 1" class="divider-vertical"></div>
  </ng-container>
</div>

